import { useMediaQuery } from '@vueuse/core';
import { computed } from 'vue';

import { SIDEBAR_BREAKPOINT_PX } from '@/shared/config';

const MOBILE_BREAKPOINT = SIDEBAR_BREAKPOINT_PX;

/**
 * Реактивный флаг mobile: `true`, когда ширина viewport < `MOBILE_BREAKPOINT`
 * (1280, `SIDEBAR_BREAKPOINT_PX`). Инверсия desktop-медиазапроса `min-width`,
 * чтобы сохранить прежнюю границу (< 1280), а не `<= 1279`.
 */
export function useIsMobile() {
  const isDesktop = useMediaQuery(`(min-width: ${MOBILE_BREAKPOINT}px)`);
  const isMobile = computed(() => !isDesktop.value);

  return { isMobile };
}
